import React from "react";
import Modal from "react-bootstrap/Modal";
import { Carousel } from "react-bootstrap";

const NoticeDialog = (props) => {
  return (
    <React.Fragment>
      <Modal show={props.open} onHide={props.handleClose} size="lg" centered>
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="close"
              onClick={props.handleClose}
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div className="modal-body">
            {props.noticeData && props.noticeData.length > 0 && (
              <Carousel interval={3000} controls indicators>
                {props.noticeData.map((item, index) => (
                  <Carousel.Item key={index}>
                    <img
                      className="d-block w-100 pt-4"
                      src={item.image}
                      alt={item.title}
                    />
                    {/* If you want text inside slide */}
                    {/* <Carousel.Caption>
                      <h4>{item.title}</h4>
                      <p>{item.description}</p>
                    </Carousel.Caption> */}
                  </Carousel.Item>
                ))}
              </Carousel>
            )}
          </div>

          <div className="modal-footer text-right">
            <button
              type="button"
              className="btn btn-default"
              onClick={props.handleClose}
            >
              Close
            </button>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default NoticeDialog;
